import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isWebMidiSupported } from './midi-support';

/**
 * Blocks the whole app at entry on browsers without the Web MIDI API (Safari,
 * Firefox, iOS), redirecting to a screen recommending Chrome/Edge (#410).
 */
@Injectable({
  providedIn: 'root',
})
export class BrowserSupportGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return isWebMidiSupported() ? true : this.router.createUrlTree(['/unsupported-browser']);
  }
}
